export default __webpack_public_path__ + "static/media/kitchen3-afterH-480w.ae8d7212.png";